<template>
  <v-app>
    <Header />
    <router-view />
  </v-app>
</template>

<script>
import Header from '@/components/HeaderComponent.vue'

export default {
  name: 'HomeView',
  components: {
    Header
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: transparent;
}
</style>
